var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{class:{
    'tabs-title': true,
    'is-active': _vm.active,
  }},[_c('a',{on:{"click":_vm.onTabClick}},[_vm._v(" "+_vm._s(_vm.name)+" "),(_vm.showBadge)?_c('span',{staticClass:"badge"},[_vm._v(" "+_vm._s(_vm.getItemCount)+" ")]):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }